// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__1Ei-N","balanceDisclaimer":"posDashboard_balanceDisclaimer__3HeeY"};